// src/services/supervisorService.js
import api from '../services/api';

export const listarSupervisores = async () => {
    const response = await api.get('/supervisores');
    console.log('Dados dos supervisores:', response.data); // Verifique a estrutura dos dados
    return response;
};

export const obterSupervisor = async (id) => {
    return api.get(`/supervisores/${id}`);
};

export const criarSupervisor = async (supervisor) => {
    return api.post('/supervisores', supervisor);
};

export const atualizarSupervisor = async (id, supervisor) => {
    return api.put(`/supervisores/${id}`, supervisor);
};

export const excluirSupervisor = async (id) => {
    return api.delete(`/supervisores/${id}`);
};